<template>
  <div class="bettingRecord-user" :style="{ '--height': height, }">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ $t("head.myteam") }}</div>
      <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="data-time-picker">
      <div>
        <div class="dataPicker">
          <input type="text" name="" id="" v-model="uid" value="" :placeholder="tips2" />
        </div>
        <van-button color="#F8C007" style="background: unset; width: 4.5rem;" plain @click="awardInfoItem()">
          {{ $t("myteam.select") }}
        </van-button>
      </div>
    </div>
    <div class="friends-category">
      <div class="item" v-for="(item, index) in $t('myteam.friendsCategoryList')" :key="index"
        :class="{ 'item-atcive': friendsCategoryIndex === index }" @click="friendsCategoryClick(index)">
        {{ item }}
      </div>
    </div>
    <div class="money">
      <p @click="changeMoneyType('USDT')" :class="moneyType == 'USDT' ? 'active' : ''">
        USDT
      </p>
      <p @click="changeMoneyType('TRX')" :class="moneyType == 'TRX' ? 'active' : ''">
        TRX
      </p>
    </div>
    <div class="bettingmoney-view">
      <div class="bettingmoney">
        <div>
          {{ $t("myteam.time") }}
        </div>
        <div>
          UID
        </div>
        <div>
          {{ $t("myteam.jryj") }}
        </div>
        <div>
          {{ $t("myteam.jrsy") }}
        </div>
        <div>
          {{ $t("myteam.ljsy") }}
        </div>
        <!-- <div>
          {{ $t("myteam.money") }}
        </div>
        <div>
          {{ $t("myteam.people") }}
        </div>
        <div>
          {{ $t("spread.group") }}
        </div>
        <div>
          {{ $t("myteam.zsyj") }}
        </div>
        <div>
          {{ $t("myteam.tdyj") }}
        </div> -->
      </div>
      <div class="bettingmoney-span" v-for="(item, index) in problemList" :key="index">
        <div>
          {{ item.createTime.slice(0, 10) }}
        </div>
        <div>
          {{ item.uid }}
        </div>
        <div>
          {{ item.todayResults }}
        </div>
        <div>
          {{ item.todayEarnings }}
        </div>
        <div>
          {{ item.cumulativeIncome }}
        </div>
        <!-- <div>
          {{ item.todayCommission }}
        </div>
        <div>
          {{ item.directNumber }}
        </div>
        <div>
          {{ item.teamNumber }}
        </div>
        <div>
          {{ item.directPerformance }}
        </div>
        <div>
          {{ item.teamPerformance }}
        </div> -->
      </div>
    </div>

    <!-- <ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
			<div class="details-lists" v-for="(item, index) in number" :key="index">
				<div>
					100
				</div>
				<div>
					195
				</div>
				<div>
					2022/03/26
				</div>
			</div>
		</ul> -->
  </div>
</template>

<script>
import { awardInfoItem } from '@/utils/request'
export default {
  data() {
    return {
      moneyType: 'USDT',
      number: 10,
      monthValue: '',
      dataPickerShow: false,
      dataPickerRange: '',
      minDate: new Date(2010, 1, 1),
      maxDate: new Date(2050, 12, 31),
      height: '', //屏幕高度
      uid: '',
      problemList: '',
      tips1: this.$t('transactiondetails.select_date'),
      tips2: this.$t('myteam.zsxx'), //请输入UID可查看直属玩家信息
      friendsCategoryIndex: -1
    }
  },
  //获取屏幕高度
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    this.awardInfoItem()
  },
  methods: {
    awardInfoItem(level) {
      awardInfoItem({
        id: this.uid,
        coin: this.moneyType,
        level: this.friendsCategoryIndex != -1 ? this.friendsCategoryIndex + 1 : level
      }).then(res => {
        console.log(res)
        this.problemList = res.data.records
      })
    },
    onConfirm(value) {
      this.dataPickerRange = value[0].getFullYear() + '-' + (value[0].getMonth() + 1) + '-' + value[0].getDate() + ' ~ ' + value[1].getFullYear() + '-' + (value[1].getMonth() + 1) + '-' + value[1].getDate()
      this.dataPickerShow = false
    },
    load() {
      this.number += 10
    },
    //选择币种类型
    changeMoneyType(item) {
      this.moneyType = item
      this.awardInfoItem()
    },
    toBack() {
      this.$router.go(-1)
    },
    friendsCategoryClick(index) {
      this.friendsCategoryIndex = index
      this.awardInfoItem(index + 1)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 12.5rem;
}

/deep/ .el-input__inner {
  background: #161414;
  border: unset !important;
}

.bettingRecord-user {
  width: 100vw;
  height: var(--height);
  background: #0c0b0b;

  .data-time-picker {
    height: 4rem;
    padding: 0 0.9375rem;

    >div {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .dataPicker {
        width: 100%;
        margin-right: 0.9375rem;
        background: #161414;

        input {
          padding: 0.75rem 0.9375rem;
          background: #161414;
          border-radius: 0.25rem;
          opacity: 1;
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          width: 80%;
        }

        >p {
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }

      >p {
        display: block;
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        height: 1rem;
      }
    }
  }

  .friends-category {
    display: flex;
    width: 21.5625rem;
    height: 2.375rem;
    margin: auto;
    background: #161414;
    border-radius: 0.25rem;
    border: 1px solid #272727;

    .item {
      flex: 1;
      height: 100%;
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #555555;
      line-height: 2.375rem;
      text-align: center;
    }

    .item-atcive {
      background: #ffc400;
      border-radius: 0.25rem;
      color: #0c0b0b;
    }
  }

  .infinite-list {
    height: calc(var(--height) - 11.75rem);
  }

  .bettingmoney-view {
    overflow: auto;

    .bettingmoney {
      display: -webkit-box;
      height: 2.6875rem;
      background: #131313;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      text-align: center;

      div {
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        border-right: 1px solid #272727;
        width: 5.25rem;
        line-height: 2.6875rem;
      }
    }

    .bettingmoney-span {
      display: -webkit-box;
      height: 2.6875rem;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      text-align: center;

      div {
        font-size: 0.75rem;
        color: #999999;
        border-right: 1px solid #272727;
        border-bottom: 1px solid #272727;
        width: 5.25rem;
        line-height: 2.6875rem;
      }
    }
  }

  .details-lists {
    padding: 0.9375rem 0.9375rem;
    border-bottom: 0.0625rem solid #272727;
    display: flex;
    justify-content: space-between;

    div {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      width: 5.625rem;
    }

    div:nth-child(1) {
      text-align: left;
    }

    div:nth-child(2) {
      text-align: center;
    }

    div:nth-child(3) {
      text-align: right;
    }

    // .item-top {
    // 	// display: flex;
    // 	// justify-content: space-between;
    // 	padding-bottom: 0.5rem;

    // 	>p {
    // 		font-size: 0.8125rem;
    // 		font-family: PingFang SC-Medium, PingFang SC;
    // 		font-weight: 500;
    // 		color: #ffffff;
    // 	}
    // }

    // .item-bottom {
    // 	// display: flex;
    // 	// justify-content: space-between;

    // 	>p {
    // 		font-size: 0.8125rem;
    // 		font-family: PingFang SC-Medium, PingFang SC;
    // 		font-weight: 500;
    // 		color: #999999;
    // 	}
    // }
  }

  .money {
    display: flex;
    justify-content: space-around;
    padding: 1rem 0;

    .active {
      color: #ffc400 !important;
      border-bottom: 0.0625rem solid #ffc400;
    }

    >p {
      font-size: 0.875rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      padding-bottom: 0.25rem;
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/user/myteam.vue